<template>
  <div style="padding-bottom: 50px">
    <div class="tui-tableTitle" style="font-weight: bold">
      各类食物每人每日一餐两点消耗量
    </div>
    <div>
      <table cellspacing="0">
        <thead>
          <tr>
            <th rowspan="2">食品类别</th>
            <th colspan="4">谷类及制品</th>
            <th colspan="2">乳类及制品</th>
            <th colspan="2">谷类及制品</th>
          </tr>
          <tr>
            <th>米类</th>
            <th>面食类</th>
            <th>糕点</th>
            <th>粗粮</th>
            <th>乳类</th>
            <th>代乳类</th>
            <th>干豆类</th>
            <th>豆制品</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>推荐摄入量</td>
            <td colspan="4" style="color: red">87.5-125g</td>
            <td colspan="2" style="color: red">125-250g</td>
            <td colspan="2" style="color: red">15-25g</td>
          </tr>
          <tr>
            <td rowspan="2">本月总量（斤）</td>
            <td colspan="4">0.0</td>
            <td colspan="2">0.0</td>
            <td colspan="2">0.0</td>
          </tr>
          <tr>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
          </tr>
          <tr>
            <td rowspan="2">人均消耗量（g）</td>
            <td colspan="4">#DIV</td>
            <td colspan="2">#DIV</td>
            <td colspan="2">#DIV</td>
          </tr>
          <tr>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 30px">
      <table cellspacing="0">
        <thead>
          <tr>
            <th rowspan="2">食品类别</th>
            <th colspan="4">动物类及制品</th>
            <th colspan="2">蔬菜类</th>
          </tr>
          <tr>
            <th>畜肉类</th>
            <th>禽肉类</th>
            <th>鱼虾类</th>
            <th>蛋类</th>
            <th>绿橙蔬菜</th>
            <th>浅色蔬菜</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>推荐摄入量</td>
            <td colspan="4" style="color: red">50-62.5g</td>
            <td colspan="2" style="color: red">75-100g</td>
          </tr>
          <tr>
            <td rowspan="2">本月总量（斤）</td>
            <td colspan="4">0.0</td>
            <td colspan="2">0.0</td>
          </tr>
          <tr>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
            <td>0.0</td>
          </tr>
          <tr>
            <td rowspan="2">人均消耗量（g）</td>
            <td colspan="4">#DIV</td>
            <td colspan="2">#DIV</td>
          </tr>
          <tr>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
            <td>#DIV</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 30px">
      <table cellspacing="0">
        <thead>
          <tr>
            <th rowspan="2">食品类别</th>
            <th colspan="2">鲜果及干果类</th>
            <th colspan="3">调味品</th>
            <th rowspan="2">食物品种</th>
          </tr>
          <tr>
            <th>水果类</th>
            <th>坚果类</th>
            <th>食用油</th>
            <th>糖</th>
            <th>食盐</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>推荐摄入量</td>
            <td colspan="2" style="color: red">75-100g</td>
            <td style="color: red">7g</td>
            <td style="color: red">9g</td>
            <td style="color: red">2g</td>
            <td style="color: red">>100种</td>
          </tr>
          <tr>
            <td rowspan="2">本月总量（斤）</td>
            <td colspan="2">0.0</td>
            <td rowspan="2">0.0</td>
            <td rowspan="2">0.0</td>
            <td rowspan="2">0.0</td>
            <td rowspan="4">0</td>
          </tr>
          <tr>
            <td>0.0</td>
            <td>0.0</td>
          </tr>
          <tr>
            <td rowspan="2">人均消耗量（g）</td>
            <td colspan="2">#DIV</td>
            <td rowspan="2">#DIV</td>
            <td rowspan="2">#DIV</td>
            <td rowspan="2">#DIV</td>
          </tr>
          <tr>
            <td>#DIV</td>
            <td>#DIV</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
    };
  },
};
</script>
<style lang="less" scoped>
table {
  width: 100%;

  border-collapse: collapse;
}
table caption {
  font-size: 2em;

  font-weight: bold;

  margin: 1em 0;
}
th,
td {
  border: 1px solid #ebeef5;

  text-align: center;

  padding: 20px 0;
}
table thead tr {
  background: rgb(242, 245, 255);
  font-size: 16px;

  color: #333;
}
table tbody tr {
  background-color: #fff;
}
table tbody tr:hover {
  background-color: #ccc;
}
table tbody tr td:first-child {
  font-size: 14px;
  color: #333;
}
table tfoot tr td {
  text-align: right;

  padding-right: 20px;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-box {
  width: 3.125rem;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}
.tui-tableTitle {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
  text-align: center;
}
</style>